import React from 'react'

export default function footer() {
  return (
    <footer className='pt-5 pb-3'>
        <div className="container">
            <div className="row">
                <div className="col-md-3">
                    <strong>Men's Wear</strong>
                    <ul>
                        <li><a href="#" className="fs_12">T-Shirt</a></li>
                        <li><a href="#" className="fs_12">Jeans</a></li>
                        <li><a href="#" className="fs_12">Shirt</a></li>
                        <li><a href="#" className="fs_12">Sport Shoes</a></li>
                        <li><a href="#" className="fs_12">Casual Shoes</a></li>
                        <li><a href="#" className="fs_12">Formal Shoes</a></li>
                        <li><a href="#" className="fs_12">Formal Wear</a></li>
                        <li><a href="#" className="fs_12">Watches</a></li>
                    </ul>
                </div>
                <div className="col-md-3">
                <strong>Childs & Kids</strong>
                    <ul>
                        <li><a href="#" className="fs_12">T-Shirt</a></li>
                        <li><a href="#" className="fs_12">Jeans</a></li>
                        <li><a href="#" className="fs_12">Shirt</a></li>
                        <li><a href="#" className="fs_12">Sport Shoes</a></li>
                        <li><a href="#" className="fs_12">Casual Shoes</a></li>
                        <li><a href="#" className="fs_12">Formal Shoes</a></li>
                        <li><a href="#" className="fs_12">Formal Wear</a></li>
                        <li><a href="#" className="fs_12">Watches</a></li>
                    </ul>
                </div>
                <div className="col-md-3">
                <strong>Women's Wear</strong>
                    <ul>
                        <li><a href="#" className="fs_12">T-Shirt</a></li>
                        <li><a href="#" className="fs_12">Jeans</a></li>
                        <li><a href="#" className="fs_12">Shirt</a></li>
                        <li><a href="#" className="fs_12">Sport Shoes</a></li>
                        <li><a href="#" className="fs_12">Casual Shoes</a></li>
                        <li><a href="#" className="fs_12">Formal Shoes</a></li>
                        <li><a href="#" className="fs_12">Formal Wear</a></li>
                        <li><a href="#" className="fs_12">Watches</a></li>
                    </ul>
                </div>
                <div className="col-md-3">
                <strong>Quick Links</strong>
                    <ul>
                        <li><a href="#" className="fs_12">Privacy Policy</a></li>
                        <li><a href="#" className="fs_12">Cookie Policy</a></li>
                        <li><a href="#" className="fs_12">Terms & Conditions</a></li>
                        <li><a href="#" className="fs_12">Sitemap</a></li>
                        <li><a href="#" className="fs_12">Faqs</a></li>
                        <li><a href="#" className="fs_12">Team</a></li>
                        <li><a href="#" className="fs_12">Career</a></li>
                        <li><a href="#" className="fs_12">Support</a></li>
                    </ul>
                </div>
            </div>
        </div>
        <hr />
        <p className="text-center fs_10">&copy; Copyright All rights Reserved Shipkart, Designed by <a href="#" title='AbdulWebCreator'>AbdulWebCreator</a></p>
    </footer>
  )
}
